import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders children into a fixed-position layer attached to <body>, escaping
 * every ancestor stacking context (including ones created by `transform` on
 * the page-stagger animation). Used for popovers/tooltips that need to sit
 * above the bottom nav (z-index 9999) and any sibling cards.
 */
export const PopupPortal = ({ children, style, className, dataTestId }) => {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const el = document.createElement('div');
    el.style.position = 'fixed';
    el.style.top = '0';
    el.style.left = '0';
    el.style.width = '100%';
    el.style.height = '0';
    el.style.zIndex = '100000';
    el.style.pointerEvents = 'none';
    if (dataTestId) el.dataset.testid = `${dataTestId}-portal-root`;
    document.body.appendChild(el);
    setContainer(el);
    return () => {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
  }, [dataTestId]);

  if (!container) return null;
  return createPortal(
    <div className={className} style={{ pointerEvents: 'auto', ...style }}>
      {children}
    </div>,
    container,
  );
};

export default PopupPortal;
